
export const ERNIE_TITLE = 'ernie_title';
export const ERNIE_DESC = 'ernie_desc';
export const ERNIE_LABEL = 'ernie_label';

export const SHOW_REPLY_POP = 'show_ernie_reply_pop'; // 存储当前时间
export const TIME_DIFF = 7; // 时间差 控制七天内不再显示文心问答授权拦截气泡

export const DEFAULT_REF = {
    timer: null,
    curUniqueId: '',
    ernieTextArrTemp: []
};

export const REPLAY_OPTIONS = [
    {
        value: 0,
        label: '不重复'
    },
    {
        value: 1,
        label: '每天'
    }
];

export const CUSTOMER_REPLAY_OPTIONS = [
    {
        value: 0,
        label: '不重复'
    }
];

export const LIMIT_REPLAY_OPTIONS = [
    {
        value: 1,
        label: '每天'
    }
];

export const NAME_MAP = {
    title: '标题',
    desc: '直播简介',
    label: '标签'
};